export default __webpack_public_path__ + "static/media/TemplateThree.e57b9bdc.jpeg";